import '../../css/base.css';

const Kitchen = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Kitchen</h2>
      <p className="your-stay-text">The kitchen is well resourced with an electric double oven, microwave,
                                    American style fridge freezer and dishwasher. All instructions can be
                                    found in a folder in the kitchen drawer next to the sink.
      </p>                                            
      <p className="your-stay-text">We have stocked the kitchen with all the utensils, crockery and equipment
                                    we think you will need to cook up a feast. We also leave a supply of basic
                                    store cupboard ingredients such as cooking oil, salt, pepper, herbs, tea
                                    bags, sugar etc for guest use. We do ask that if you use up all the supplies
                                    that you replace them for the next guests.
      </p>
      <p className="your-stay-text">The utility room houses a washing machine and tumble dryer and an
                                    electric drying rack for wet clothes. An airing cupboard is situated in the
                                    kitchen for additional drying. We kindly ask that muddy walking boots,
                                    wellies and wet waterproofs are kept in the utility and boot room.
      </p>
      <p className="your-stay-text">We have a spare dog bed which we leave in the utility which guest pets
                                    are welcome to use. We also leave a couple of spare towels in the boot
                                    room for drying your four legged friends.
      </p>
    </div>
  );
}

export default Kitchen;